import { render, staticRenderFns } from "./CollegeDetail.vue?vue&type=template&id=0a4ebd7e&scoped=true"
import script from "./CollegeDetail.vue?vue&type=script&lang=ts"
export * from "./CollegeDetail.vue?vue&type=script&lang=ts"
import style0 from "./CollegeDetail.vue?vue&type=style&index=0&id=0a4ebd7e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4ebd7e",
  null
  
)

export default component.exports